import { frozen, registerRootStore } from "mobx-keystone";
import { PlansWorkspace } from "./PlansWorkspace";

export const runCreatePlansWorkspace = () => {
  const workSpace = new PlansWorkspace({
    plansData: frozen({}),
  });

  registerRootStore(workSpace);
  return workSpace;
};
